<template>
<svg x="0px" y="0px" viewBox="0 0 716 520" class="boat-origami">
<g id="boat_2_">
	<g>
		<polyline id="path-11_3_" class="st0" points="567.08,364.59 433.63,273.03 716,13 567.08,364.59 		"/>
	</g>
	<g>
		<polyline id="path-9_3_" class="st0" points="148.07,424.94 433.63,273.03 567.08,364.59 148.07,424.94 		"/>
	</g>
	<g>
		<polyline id="path-7_3_" class="st0" points="471.2,238.43 357.58,47.86 537.53,177.35 471.2,238.43 		"/>
	</g>
	<g>
		<polyline id="path-5_3_" class="st0" points="433.63,273.03 433.63,273.03 219.07,255.84 357.58,47.86 471.2,238.43 
			433.63,273.03 		"/>
	</g>
	<g>
		<polyline id="path-3_3_" class="st0" points="219.07,255.84 298.76,136.17 219.07,255.84 		"/>
	</g>
	<g>
		<polyline id="path-1_5_" class="st0" points="298.76,136.17 308.4,121.7 298.76,136.17 		"/>
	</g>
	<g id="Page-1_2_">
		<g id="Ryoma_desktop_404_2_" transform="translate(-250.000000, -86.000000)">
			<g id="boat_3_" transform="translate(250.000000, 86.000000)">
				<polyline id="Fill-3_2_" class="st1" points="616.98,502.17 361.36,443.98 128.93,474.73 148.07,424.94 567.08,364.59 
					636.58,200.52 699.79,171.48 628.18,323.1 616.98,502.17 				"/>
				<line id="Fill-4_2_" class="st2" x1="479.52" y1="134.35" x2="479.52" y2="134.35"/>
				<polyline id="Fill-5_2_" class="st3" points="219.07,255.84 231.44,139.05 16.08,239.58 219.07,255.84 				"/>
				<polyline id="Fill-6_2_" class="st3" points="275.25,171.48 271.08,177.75 275.25,171.48 				"/>
				<polyline id="Fill-7_2_" class="st3" points="310.55,118.47 231.44,139.05 298.76,136.17 310.55,118.47 				"/>
				<polyline id="Fill-8_2_" class="st3" points="537.53,177.35 716,13 417.16,90.74 537.53,177.35 				"/>
				<polyline id="Fill-9_2_" class="st4" points="219.07,255.84 298.76,136.17 231.44,139.05 219.07,255.84 				"/>
				<polyline id="Fill-10_2_" class="st5" points="471.2,238.43 537.53,177.35 357.58,47.86 471.2,238.43 				"/>
				<polyline id="Fill-11_2_" class="st0" points="433.63,273.03 16.08,239.58 148.07,424.94 433.63,273.03 				"/>
				<polyline id="Fill-12_2_" class="st4" points="433.63,273.03 148.07,424.94 567.08,364.59 433.63,273.03 				"/>
				<polyline id="Fill-13_2_" class="st6" points="586.43,132.32 433.63,273.03 567.08,364.59 716,13 586.43,132.32 				"/>
				<polyline id="Fill-14_2_" class="st0" points="275.25,171.48 219.07,255.84 433.63,273.03 471.2,238.43 357.58,47.86 
					275.25,171.48 				"/>
				<g id="Group-17_1_" transform="translate(215.439488, 83.072000)">
					<g id="Clip-16_1_">
					</g>
					<defs>
						<filter id="Adobe_OpacityMaskFilter" filterUnits="userSpaceOnUse" x="83.32" y="38.62" width="9.64" height="14.48">
							<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
						</filter>
					</defs>
					<mask maskUnits="userSpaceOnUse" x="83.32" y="38.62" width="9.64" height="14.48" id="mask-2_4_">
						<g class="st7">
							<polyline id="path-1_4_" class="st0" points="83.32,53.1 92.96,38.62 83.32,53.1 							"/>
						</g>
					</mask>
					<polyline id="Fill-15_2_" class="st8" points="83.32,53.1 92.96,38.62 83.32,53.1 					"/>
				</g>
				<g id="Group-20_1_" transform="translate(154.895488, 94.336000)">
					<g id="Clip-19_1_">
					</g>
					<defs>
						<filter id="Adobe_OpacityMaskFilter_1_" filterUnits="userSpaceOnUse" x="64.17" y="41.84" width="79.7" height="119.67">
							<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
						</filter>
					</defs>
					<mask maskUnits="userSpaceOnUse" x="64.17" y="41.84" width="79.7" height="119.67" id="mask-4_1_">
						<g class="st9">
							<polyline id="path-3_1_" class="st0" points="64.17,161.5 143.87,41.84 64.17,161.5 							"/>
						</g>
					</mask>
					<polyline id="Fill-18_2_" class="st10" points="64.17,161.5 143.87,41.84 64.17,161.5 					"/>
				</g>
				<g id="Group-23_1_" transform="translate(154.895488, 26.752000)">
					<g id="Clip-22_1_">
					</g>
					<defs>
						<filter id="Adobe_OpacityMaskFilter_2_" filterUnits="userSpaceOnUse" x="64.17" y="21.11" width="252.14" height="225.17">
							<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
						</filter>
					</defs>
					<mask maskUnits="userSpaceOnUse" x="64.17" y="21.11" width="252.14" height="225.17" id="mask-6_1_">
						<g class="st11">
							<polyline id="path-5_1_" class="st0" points="278.74,246.28 278.74,246.28 64.17,229.09 202.68,21.11 316.31,211.68 
								278.74,246.28 							"/>
						</g>
					</mask>
					<polyline id="Fill-21_2_" class="st12" points="278.74,246.28 278.74,246.28 64.17,229.09 202.68,21.11 316.31,211.68 
						278.74,246.28 					"/>
				</g>
				<g id="Group-26_1_" transform="translate(260.495488, 26.752000)">
					<g id="Clip-25_1_">
					</g>
					<defs>
						<filter id="Adobe_OpacityMaskFilter_3_" filterUnits="userSpaceOnUse" x="97.08" y="21.11" width="179.95" height="190.57">
							<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
						</filter>
					</defs>
					<mask maskUnits="userSpaceOnUse" x="97.08" y="21.11" width="179.95" height="190.57" id="mask-8_1_">
						<g class="st13">
							<polyline id="path-7_1_" class="st0" points="210.71,211.68 97.08,21.11 277.03,150.6 210.71,211.68 							"/>
						</g>
					</mask>
					<polyline id="Fill-24_2_" class="st14" points="210.71,211.68 97.08,21.11 277.03,150.6 210.71,211.68 					"/>
				</g>
				<g id="Group-29_1_" transform="translate(100.687488, 198.528000)">
					<g id="Clip-28_1_">
					</g>
					<defs>
						<filter id="Adobe_OpacityMaskFilter_4_" filterUnits="userSpaceOnUse" x="47.38" y="74.5" width="419.02" height="151.91">
							<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
						</filter>
					</defs>
					<mask maskUnits="userSpaceOnUse" x="47.38" y="74.5" width="419.02" height="151.91" id="mask-10_1_">
						<g class="st15">
							<polyline id="path-9_1_" class="st0" points="47.38,226.41 332.94,74.5 466.4,166.06 47.38,226.41 							"/>
						</g>
					</mask>
					<polyline id="Fill-27_2_" class="st16" points="47.38,226.41 332.94,74.5 466.4,166.06 47.38,226.41 					"/>
				</g>
				<g id="Group-32_1_" transform="translate(318.927488, 0.000000)">
					<g id="Clip-31_1_">
					</g>
					<defs>
						<filter id="Adobe_OpacityMaskFilter_5_" filterUnits="userSpaceOnUse" x="114.7" y="13" width="282.37" height="351.59">
							<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
						</filter>
					</defs>
					<mask maskUnits="userSpaceOnUse" x="114.7" y="13" width="282.37" height="351.59" id="mask-12_1_">
						<g class="st17">
							<polyline id="path-11_1_" class="st0" points="248.16,364.59 114.7,273.03 397.07,13 248.16,364.59 							"/>
						</g>
					</mask>
					<polyline id="Fill-30_2_" class="st18" points="248.16,364.59 114.7,273.03 397.07,13 248.16,364.59 					"/>
				</g>
			</g>
		</g>
	</g>
</g>
</svg>

</template>

<script>
export default {
    name: 'boat-origami'
}
</script>

<style lang="scss" scoped>
svg {
    transform: translateY(-40px);

	.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}
	.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#AAB8BB;}
	.st2{fill:none;}
	.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#D8D8D8;}
	.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#EFEFEE;}
	.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#EBEBEB;}
	.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#E5E5E5;}
	.st7{filter:url(#Adobe_OpacityMaskFilter);}
	.st8{mask:url(#mask-2_4_);fill:none;}
	.st9{filter:url(#Adobe_OpacityMaskFilter_1_);}
	.st10{mask:url(#mask-4_1_);fill:none;}
	.st11{filter:url(#Adobe_OpacityMaskFilter_2_);}
	.st12{mask:url(#mask-6_1_);fill:none;}
	.st13{filter:url(#Adobe_OpacityMaskFilter_3_);}
	.st14{mask:url(#mask-8_1_);fill:none;}
	.st15{filter:url(#Adobe_OpacityMaskFilter_4_);}
	.st16{mask:url(#mask-10_1_);fill:none;}
	.st17{filter:url(#Adobe_OpacityMaskFilter_5_);}
	.st18{mask:url(#mask-12_1_);fill:none;}
}
</style>